import { DesigntimeComponent } from './DesigntimeComponent.js'
import componentHelpers from './componentHelpers.js'
import * as $ from 'jquery';

class FiveButtons extends DesigntimeComponent {
    static staticName = "Buttons (1-5)";
    static staticId = "fiveButtons";
    runtimeValue = null;

    constructor(identifyer) {
        super(identifyer, 1);

        this.disableNextButton();

        this.values = {
            header: { value: "How much?" },
            button1: { value: "Less" },
            button2: { value: "-" },
            button3: { value: "Same" },
            button4: { value: "-" },
            button5: { value: "More" },
            buttontext: { value: "Next" }
        };
    }

    getRuntimeView(context) {
        var $view = $("<div></div>");
        $view.append("<h2>" + this.values.header.value + "</h2>")

        $view.append(this.getButton(this.values.button1.value, 1));
        $view.append($("<br />"));
        $view.append(this.getButton(this.values.button2.value, 2));
        $view.append($("<br />"));
        $view.append(this.getButton(this.values.button3.value, 3));
        $view.append($("<br />"));
        $view.append(this.getButton(this.values.button4.value, 4));
        $view.append($("<br />"));
        $view.append(this.getButton(this.values.button5.value, 5));
        $view.append($("<br />"));

        return $view;
    }

    getButton(buttonText, buttonValue) {
        let $button = $(`<input class='sid-question-button' type='button' value='${buttonText}' data-result='${buttonValue}'></input >`);
        $button.click(function (e) {
            componentHelpers.getRtFrame(this.id).find(".sid-question-button").removeClass("sid-button-selected");
            $(e.currentTarget).addClass("sid-button-selected");
            this.runtimeValue = $(e.currentTarget).data("result");
            this.enableNextButton();
        }.bind(this));
        return $button;
    }

    getOutput() {
        return {
            value: this.runtimeValue,
        };
    }

    output = [
        { name: "value", type: "number" }
    ];
}

export { FiveButtons }
